import React from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import Icon, { IconSizes } from '../components/foundations/Icon';
import HtmlArtifactFrame from './HtmlArtifactFrame';
import css from './HtmlArtifactView.css';

const TRANSLATION_PREFIX = 'STATIC.PAGES.ARTIFACT_VIEW';

const ArtifactProvenance = ({ showVisibility, translate }) => (
    <div className={css.provenance}>
        <span className={css.badge}>{translate(`${TRANSLATION_PREFIX}.GENERATED_BADGE`)}</span>
        <span className={css.provenanceText}>{translate(`${TRANSLATION_PREFIX}.GENERATED_NOTICE`)}</span>
        {showVisibility && (
            <>
                <span className={css.divider} />
                <Icon name="lock" size={IconSizes.XX_SMALL} className={css.lockIcon} interactive={false} />
                <span className={css.provenanceText}>{translate(`${TRANSLATION_PREFIX}.VISIBILITY_PRIVATE`)}</span>
            </>
        )}
    </div>
);

ArtifactProvenance.propTypes = {
    showVisibility: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

const ArtifactSurface = ({ content, isLoading, error, frameKey, translate }) => {
    if (error !== null) {
        return (
            <div className={css.state}>
                <p className={css.stateTitle}>{translate(`${TRANSLATION_PREFIX}.LOAD_FAILED`)}</p>
                <p className={css.stateDetail}>{error}</p>
            </div>
        );
    }
    const loadingState = <div className={css.state}>{translate(`${TRANSLATION_PREFIX}.LOADING`)}</div>;
    if (isLoading || content === null) {
        return loadingState;
    }

    return (
        <HtmlArtifactFrame
            key={frameKey}
            html={content}
            title={translate(`${TRANSLATION_PREFIX}.FRAME_TITLE`)}
            placeholder={loadingState}
        />
    );
};

ArtifactSurface.propTypes = {
    content: PropTypes.string,
    isLoading: PropTypes.bool,
    error: PropTypes.string,
    frameKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    translate: PropTypes.func.isRequired,
};

const HtmlArtifactView = ({
    content = null,
    isLoading = false,
    error = null,
    frameKey,
    showVisibility = false,
    translate,
}) => (
    <div className={css.view}>
        <ArtifactProvenance showVisibility={showVisibility} translate={translate} />
        <div className={css.surface}>
            <ArtifactSurface
                content={content}
                isLoading={isLoading}
                error={error}
                frameKey={frameKey}
                translate={translate}
            />
        </div>
    </div>
);

HtmlArtifactView.propTypes = {
    content: PropTypes.string,
    isLoading: PropTypes.bool,
    error: PropTypes.string,
    frameKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    showVisibility: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(HtmlArtifactView);
